<template>
  <span>
    Payment reminder sent to
    {{ eventLog.customer.emailAddress }}
  </span>
</template>
<script>
export default {
  name: "recentActivityTableDescriptionBookingPaymentReminderSent",
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
